import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SessionData, SessionService } from "@app/core/services/session.service";
import { isNotEmpty } from "@app/core/utils";
import * as countries from "assets/statics/countries.json";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "app-distribution-policy-annex",
    templateUrl: "./distribution-policy-annex.component.html",
    styleUrls: ["./distribution-policy-annex.component.scss", "../legal-documents.scss"],
    standalone: false,
})
export class DistributionPolicyAnnexComponent implements OnInit {
    show: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    annexFlag: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    hasAllUserInfo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    name: BehaviorSubject<string> = new BehaviorSubject<string>("");
    address: BehaviorSubject<string> = new BehaviorSubject<string>("");

    constructor(private sessionService: SessionService, private route: ActivatedRoute) {}

    ngOnInit() {
        this.show.next(false);
        this.loading.next(true);

        const accountUid = this.route.snapshot.queryParams.accountUid;
        this.annexFlag.next(this.route.snapshot.queryParams.annex === "true");

        if (accountUid) {
            this.getAccountDataByUid(accountUid);
        } else {
            this.sessionService.sessionData.subscribe({
                next: (sessionData: SessionData) => {
                    this.show.next(false);
                    this.loading.next(true);

                    if (!sessionData || !sessionData.account) {
                        this.loading.next(false);
                        return;
                    }

                    this.getAccountDataByUid(sessionData?.account?.uid);
                },
                error: () => {
                    this.loading.next(false);
                },
            });
        }
    }

    getAccountDataByUid(accountUid: string) {
        this.show.next(this.annexFlag.value);
        this.loading.next(true);

        this.sessionService.getAccountData(accountUid).subscribe({
            next: (account) => {
                if (!account) {
                    this.show.next(false);
                    this.loading.next(false);
                    return;
                }
                if (!account.settings["developer.distributionPolicy"]) {
                    this.show.next(false);
                } else {
                    const country: string = (() => {
                        if (!account.settings["country"]) {
                            return "";
                        }

                        const countriesObject: any = countries as any;
                        const countryCode: string = account.settings["country"].toLowerCase();
                        if (Object.keys(countriesObject).includes(countryCode)) {
                            return countriesObject[countryCode];
                        }

                        return "";
                    })();

                    const addressItems: string[] = [account.settings["address"], account.settings["zipCode"], account.settings["city"], country];
                    const address: string = addressItems
                        .filter((addressItem: string) => {
                            return addressItem;
                        })
                        .join(", ");

                    this.name.next(account.settings["name"]);
                    this.address.next(address);
                    this.hasAllUserInfo.next(isNotEmpty(this.name.value) && isNotEmpty(this.address.value));
                    this.show.next(this.annexFlag.value && this.hasAllUserInfo.value);
                }
                this.loading.next(false);
            },
            error: (error) => {
                this.show.next(false);
                this.loading.next(false);
            },
        });
    }
}
